import ApiService from 'common/service/api';
import { PublicError } from 'common/service/error';
import { catchError, map } from 'rxjs/operators';

export default class GroupServiceUi extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `${this.baseURL}/groups`;
  }

  getAll(params) {
    return this.fetchCollection('', params);
  }

  getById(groupId) {
    return this.fetchResource(`/${groupId}`);
  }

  getDevices(groupId, { limit, offset, sort, query }) {
    return this.fetchCollection(`/${groupId}/devices`, {
      query,
      limit,
      offset,
      sort,
    });
  }

}
